export const getCoordinateKey = (position, precision = 5) =>
  position.map(coord => Number(coord).toFixed(precision)).join(',');

export const groupByCoordinate = (items, getPosition, precision = 5) => {
  const groups = new Map();

  items.forEach(item => {
    const position = getPosition(item);

    if (!Array.isArray(position) || position.length < 2) return;

    const key = getCoordinateKey(position, precision);

    if (!groups.has(key)) {
      groups.set(key, []);
    }

    groups.get(key).push(item);
  });

  return groups;
};
